import { createAction, props } from '@ngrx/store';
import { Steps, Workflows } from './workflows.model';

// fetch one 
export const fetchSingleRecord = createAction(
    '[Data] fetch single record workflows',
    props<{id: string}>()
);
export const fetchSingleRecordSuccess = createAction(
    '[Data] fetch single record workflows success', 
    props<{ singleData: Workflows, steps: Steps[] }>()
);
export const fetchSingleRecordFail = createAction(
    '[Data] fetch single record workflows failure', 
    props<{ error: string }>()
);

//Reset State
export const resetState = createAction(
    '[Data] reset state workflows',
);